/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Fallback_TitleInputs */



/**
* | output |
* | --- |
* | "Tournament" |
*
* @param {Tournament_Fallback_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_fallback_title = /** @type {((inputs?: Tournament_Fallback_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Fallback_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torneo")
	return /** @type {LocalizedString} */ ("Tournament")
});